import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	paymentSummary: {
		marginBottom: "8px",
	},

	payInPerson: {
		marginBottom: "8px",
	},

	paymentTitle: {
		fontSize: "18px",
		fontWeight: "bold",
		color: "#333333",
		marginBottom: "12px",
	},

	paymentTable: {
		display: "table",
		width: "100%",
	},

	paymentRow: {
		display: "table-row",
	},

	paymentLabel: {
		fontSize: "18px",
		color: "#222",
		textAlign: "left",
		width: "55%",
		display: "table-cell",
		verticalAlign: "middle",
	},

	paymentValue: {
		fontSize: "16px",
		fontWeight: "bold",
		color: "#333333",
		textAlign: "end",
		display: "table-cell",
		verticalAlign: "middle",
	},
}));

export default useStyles;
